// ./paymentApi.js
const API_BASE =
  process.env.REACT_APP_PAYMENT_API_URL || // якщо CRA
  process.env.NEXT_PUBLIC_PAYMENT_API_URL || // якщо Next
  "https://chas-maistriv.com.ua/api"; // ваш проксі/домен
//https://chas-maistriv.com.ua/api
async function parseJsonSafe(res) {
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    // ignore
  }

  if (!res.ok) {
    const message =
      data?.error || data?.message || `HTTP ${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return data;
}

export async function startInvoiceCreate(orderId) {
  const res = await fetch(`${API_BASE}/invoice/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderId }),
  });

  return parseJsonSafe(res);
}

export async function startLiqPayCheckout(orderId) {
  const res = await fetch(`${API_BASE}/liqpay/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ orderId }),
  });

  // Сервер повертає: { data, signature }
  return parseJsonSafe(res);
}
